module.exports = __webpack_public_path__ + "static/android-icon-192x192-5b82616261b0d9007d04fc418b58de62.png";